/* ============================================================
   W-Walnut — Shopify Theme JS
   ============================================================ */

/** Swiper direction: follow <html dir> so arrows + scroll match the layout (LTR vs RTL). */
window.tdGetSwiperDir = function () {
  var el = document.documentElement;
  var d = (el && el.getAttribute('dir')) || '';
  d = String(d).toLowerCase();
  if (d === 'rtl') return 'rtl';
  if (d === 'ltr') return 'ltr';
  var lang = (el && el.getAttribute('lang')) || '';
  lang = String(lang).toLowerCase();
  if (lang === 'ar' || lang.indexOf('ar-') === 0) return 'rtl';
  return 'ltr';
};

/* ── Cart Drawer ── */
window.toggleCartDrawer = function () {
  var overlay = document.getElementById('cartDrawerOverlay');
  var drawer = document.getElementById('cartDrawerBody');
  if (!overlay || !drawer) return;

  if (overlay.classList.contains('opacity-0')) {
    if (typeof closeAccountMenu === 'function') closeAccountMenu();
    if (typeof closeCustomerMenu === 'function') closeCustomerMenu();
    if (typeof closeLangSwitcher === 'function') closeLangSwitcher();
    document.body.style.overflow = 'hidden';
    overlay.classList.remove('opacity-0', 'pointer-events-none');
    drawer.classList.remove('-translate-x-full', 'ltr:-translate-x-full', 'rtl:translate-x-full');
    var mob = document.getElementById('mobileMenuOverlay');
    if (mob && !mob.classList.contains('opacity-0')) {
      toggleMobileMenu();
    }
  } else {
    document.body.style.overflow = '';
    overlay.classList.add('opacity-0', 'pointer-events-none');
    drawer.classList.remove('-translate-x-full');
    drawer.classList.add('ltr:-translate-x-full', 'rtl:translate-x-full');
  }
};

/* ── Mobile Menu ── */
window.toggleMobileMenu = function () {
  var overlay = document.getElementById('mobileMenuOverlay');
  var drawer = document.getElementById('mobileMenuDrawer');
  if (!overlay || !drawer) return;

  if (overlay.classList.contains('opacity-0')) {
    if (typeof closeAccountMenu === 'function') closeAccountMenu();
    if (typeof closeCustomerMenu === 'function') closeCustomerMenu();
    var searchO = document.getElementById('searchOverlay');
    if (searchO && !searchO.classList.contains('opacity-0') && typeof toggleSearch === 'function') toggleSearch();
    var cartO = document.getElementById('cartDrawerOverlay');
    if (cartO && !cartO.classList.contains('opacity-0') && typeof toggleCartDrawer === 'function') toggleCartDrawer();
    if (typeof closeLangSwitcher === 'function') closeLangSwitcher();
    document.body.style.overflow = 'hidden';
    overlay.classList.remove('opacity-0', 'pointer-events-none');
    drawer.classList.remove('ltr:-translate-x-full', 'rtl:translate-x-full', 'translate-x-full', 'translate-y-full', 'translate-y-0');
    if (typeof lucide !== 'undefined') lucide.createIcons();
  } else {
    document.body.style.overflow = '';
    overlay.classList.add('opacity-0', 'pointer-events-none');
    drawer.classList.remove('translate-y-full', 'translate-y-0');
    drawer.classList.add('ltr:-translate-x-full', 'rtl:translate-x-full');
  }
};

/* ── Account dropdown (أيقونة البروفايل) — fixed + z عالي لتجاوز محتوى الصفحة ── */
function accountMenuIsOpen() {
  var dd = document.getElementById('accountMenuDropdown');
  if (!dd) return false;
  return !dd.classList.contains('opacity-0');
}

function positionAccountMenu() {
  if (!window.matchMedia('(min-width: 1280px)').matches) return;
  var trig = document.getElementById('accountMenuTrigger');
  var dd = document.getElementById('accountMenuDropdown');
  if (!trig || !dd) return;
  var r = trig.getBoundingClientRect();
  var gap = 8;
  var w = Math.min(264, Math.floor(window.innerWidth - 24));
  dd.style.width = w + 'px';
  dd.style.top = Math.round(r.bottom + gap) + 'px';
  var left = r.left + r.width / 2 - w / 2;
  left = Math.max(12, Math.min(left, window.innerWidth - w - 12));
  dd.style.left = left + 'px';
  dd.style.right = 'auto';
}

function clearAccountMenuPosition() {
  var dd = document.getElementById('accountMenuDropdown');
  if (!dd) return;
  dd.style.top = '';
  dd.style.left = '';
  dd.style.right = '';
  dd.style.width = '';
}

function positionCustomerMenu() {
  if (!window.matchMedia('(min-width: 1280px)').matches) return;
  var trig = document.getElementById('customerMenuTrigger');
  var dd = document.getElementById('customerMenuDropdown');
  if (!trig || !dd) return;
  var r = trig.getBoundingClientRect();
  var gap = 8;
  var w = Math.min(264, Math.floor(window.innerWidth - 24));
  dd.style.width = w + 'px';
  dd.style.top = Math.round(r.bottom + gap) + 'px';
  var left = r.left + r.width / 2 - w / 2;
  left = Math.max(12, Math.min(left, window.innerWidth - w - 12));
  dd.style.left = left + 'px';
  dd.style.right = 'auto';
}

function clearCustomerMenuPosition() {
  var dd = document.getElementById('customerMenuDropdown');
  if (!dd) return;
  dd.style.top = '';
  dd.style.left = '';
  dd.style.right = '';
  dd.style.width = '';
}

var accountMenuScrollBound = false;
function customerMenuIsOpen() {
  var dd = document.getElementById('customerMenuDropdown');
  if (!dd) return false;
  return !dd.classList.contains('opacity-0');
}

function accountMenuOnScroll() {
  if (accountMenuIsOpen()) closeAccountMenu();
  if (customerMenuIsOpen()) closeCustomerMenu();
}
function accountMenuOnResize() {
  if (accountMenuIsOpen()) closeAccountMenu();
  if (customerMenuIsOpen()) closeCustomerMenu();
}
function bindAccountMenuReposition() {
  if (accountMenuScrollBound) return;
  window.addEventListener('scroll', accountMenuOnScroll, true);
  window.addEventListener('resize', accountMenuOnResize);
  accountMenuScrollBound = true;
}
function unbindAccountMenuReposition() {
  if (!accountMenuScrollBound) return;
  if (accountMenuIsOpen() || customerMenuIsOpen()) return;
  window.removeEventListener('scroll', accountMenuOnScroll, true);
  window.removeEventListener('resize', accountMenuOnResize);
  accountMenuScrollBound = false;
}

function setAccountMenuOpen(open) {
  var root = document.getElementById('accountMenuRoot');
  var dd = document.getElementById('accountMenuDropdown');
  var trig = document.getElementById('accountMenuTrigger');
  var bd = document.getElementById('accountMenuBackdrop');
  if (!dd || !trig) return;
  var desktop = window.matchMedia('(min-width: 1280px)').matches;
  if (open) {
    if (typeof closeCustomerMenu === 'function') closeCustomerMenu();
    if (desktop) {
      positionAccountMenu();
    } else {
      clearAccountMenuPosition();
      if (bd) {
        bd.classList.remove('pointer-events-none', 'opacity-0');
        bd.classList.add('pointer-events-auto', 'opacity-100');
      }
    }
    dd.classList.remove(
      'opacity-0',
      'invisible',
      'pointer-events-none',
      'max-xl:translate-y-full',
      'xl:translate-y-1',
      'xl:scale-[0.99]'
    );
    dd.classList.add(
      'opacity-100',
      'visible',
      'pointer-events-auto',
      'translate-y-0',
      'scale-100'
    );
    trig.setAttribute('aria-expanded', 'true');
    if (root) root.classList.add('account-menu-is-open');
    bindAccountMenuReposition();
    if (typeof lucide !== 'undefined') lucide.createIcons();
    window.requestAnimationFrame(function () {
      if (window.matchMedia('(min-width: 1280px)').matches) positionAccountMenu();
    });
  } else {
    unbindAccountMenuReposition();
    if (bd) {
      bd.classList.add('pointer-events-none', 'opacity-0');
      bd.classList.remove('pointer-events-auto', 'opacity-100');
    }
    dd.classList.add(
      'opacity-0',
      'invisible',
      'pointer-events-none',
      'max-xl:translate-y-full',
      'xl:translate-y-1',
      'xl:scale-[0.99]'
    );
    dd.classList.remove(
      'opacity-100',
      'visible',
      'pointer-events-auto',
      'translate-y-0',
      'scale-100'
    );
    trig.setAttribute('aria-expanded', 'false');
    if (root) root.classList.remove('account-menu-is-open');
    clearAccountMenuPosition();
  }
}

window.closeAccountMenu = function () {
  if (accountMenuIsOpen()) setAccountMenuOpen(false);
};

function setCustomerMenuOpen(open) {
  var root = document.getElementById('customerMenuRoot');
  var dd = document.getElementById('customerMenuDropdown');
  var trig = document.getElementById('customerMenuTrigger');
  var bd = document.getElementById('customerMenuBackdrop');
  if (!dd || !trig) return;
  var desktop = window.matchMedia('(min-width: 1280px)').matches;
  if (open) {
    if (typeof closeAccountMenu === 'function') closeAccountMenu();
    if (desktop) {
      positionCustomerMenu();
    } else {
      clearCustomerMenuPosition();
      if (bd) {
        bd.classList.remove('pointer-events-none', 'opacity-0');
        bd.classList.add('pointer-events-auto', 'opacity-100');
      }
    }
    dd.classList.remove(
      'opacity-0',
      'invisible',
      'pointer-events-none',
      'max-xl:translate-y-full',
      'xl:translate-y-1',
      'xl:scale-[0.99]'
    );
    dd.classList.add(
      'opacity-100',
      'visible',
      'pointer-events-auto',
      'translate-y-0',
      'scale-100'
    );
    trig.setAttribute('aria-expanded', 'true');
    if (root) root.classList.add('customer-menu-is-open');
    bindAccountMenuReposition();
    if (typeof lucide !== 'undefined') lucide.createIcons();
    window.requestAnimationFrame(function () {
      if (window.matchMedia('(min-width: 1280px)').matches) positionCustomerMenu();
    });
  } else {
    unbindAccountMenuReposition();
    if (bd) {
      bd.classList.add('pointer-events-none', 'opacity-0');
      bd.classList.remove('pointer-events-auto', 'opacity-100');
    }
    dd.classList.add(
      'opacity-0',
      'invisible',
      'pointer-events-none',
      'max-xl:translate-y-full',
      'xl:translate-y-1',
      'xl:scale-[0.99]'
    );
    dd.classList.remove(
      'opacity-100',
      'visible',
      'pointer-events-auto',
      'translate-y-0',
      'scale-100'
    );
    trig.setAttribute('aria-expanded', 'false');
    if (root) root.classList.remove('customer-menu-is-open');
    clearCustomerMenuPosition();
  }
}

window.closeCustomerMenu = function () {
  if (customerMenuIsOpen()) setCustomerMenuOpen(false);
};

window.toggleCustomerMenu = function (e) {
  if (e) e.stopPropagation();
  var dd = document.getElementById('customerMenuDropdown');
  if (!dd) return;
  if (dd.classList.contains('opacity-0')) {
    if (typeof closeLangSwitcher === 'function') closeLangSwitcher();
    var searchO = document.getElementById('searchOverlay');
    if (searchO && !searchO.classList.contains('opacity-0') && typeof toggleSearch === 'function') toggleSearch();
    var menuO = document.getElementById('mobileMenuOverlay');
    if (menuO && !menuO.classList.contains('opacity-0') && typeof toggleMobileMenu === 'function') {
      toggleMobileMenu();
    }
    var cartO = document.getElementById('cartDrawerOverlay');
    if (cartO && !cartO.classList.contains('opacity-0') && typeof toggleCartDrawer === 'function') toggleCartDrawer();
    if (typeof closeAccountMenu === 'function') closeAccountMenu();
    setCustomerMenuOpen(true);
  } else {
    setCustomerMenuOpen(false);
  }
};

window.toggleAccountMenu = function (e) {
  if (e) e.stopPropagation();
  var dd = document.getElementById('accountMenuDropdown');
  if (!dd) return;
  if (dd.classList.contains('opacity-0')) {
    if (typeof closeLangSwitcher === 'function') closeLangSwitcher();
    var searchO = document.getElementById('searchOverlay');
    if (searchO && !searchO.classList.contains('opacity-0')) toggleSearch();
    var menuO = document.getElementById('mobileMenuOverlay');
    if (menuO && !menuO.classList.contains('opacity-0')) toggleMobileMenu();
    var cartO = document.getElementById('cartDrawerOverlay');
    if (cartO && !cartO.classList.contains('opacity-0')) toggleCartDrawer();
    setAccountMenuOpen(true);
  } else {
    setAccountMenuOpen(false);
  }
};

document.addEventListener('click', function (e) {
  var root = document.getElementById('accountMenuRoot');
  if (root && accountMenuIsOpen() && !root.contains(e.target)) closeAccountMenu();
  var croot = document.getElementById('customerMenuRoot');
  if (croot && customerMenuIsOpen() && !croot.contains(e.target)) closeCustomerMenu();
});

function tdLangOpenRoot() {
  return window.__tdLangOpenRoot || null;
}

function langSwitcherIsOpen() {
  var roots = document.querySelectorAll('.td-lang-switcher');
  for (var i = 0; i < roots.length; i++) {
    var p = roots[i].querySelector('.td-lang-switcher-panel');
    if (p && !p.classList.contains('invisible')) return true;
  }
  return false;
}

function positionLangSwitcherPanel() {
  var root = tdLangOpenRoot();
  if (!root) return;
  if (root.dataset.tdLangDrawer === 'true' || root.closest('#mobileMenuDrawer')) {
    var p0 = root.querySelector('.td-lang-switcher-panel');
    if (p0) {
      p0.style.position = '';
      p0.style.top = '';
      p0.style.left = '';
      p0.style.right = '';
      p0.style.zIndex = '';
    }
    return;
  }
  var p = root.querySelector('.td-lang-switcher-panel');
  var t = root.querySelector('.td-lang-switcher-trigger');
  if (!p || !t || p.classList.contains('invisible')) return;
  var r = t.getBoundingClientRect();
  var gap = 8;
  p.style.position = 'fixed';
  p.style.zIndex = '560';
  p.style.top = Math.round(r.bottom + gap) + 'px';
  var w = p.offsetWidth || 176;
  var cx = r.left + r.width / 2;
  var left = cx - w / 2;
  left = Math.max(10, Math.min(left, window.innerWidth - w - 10));
  p.style.left = left + 'px';
  p.style.right = 'auto';
}

function onLangSwitcherReposition() {
  if (langSwitcherIsOpen()) positionLangSwitcherPanel();
}

window.closeLangSwitcher = function () {
  var roots = document.querySelectorAll('.td-lang-switcher');
  for (var i = 0; i < roots.length; i++) {
    var p = roots[i].querySelector('.td-lang-switcher-panel');
    var tr = roots[i].querySelector('.td-lang-switcher-trigger');
    if (!p || !tr) continue;
    p.classList.add('pointer-events-none', 'invisible', 'opacity-0', 'scale-[0.98]');
    p.classList.remove('pointer-events-auto', 'visible', 'opacity-100', 'scale-100');
    tr.setAttribute('aria-expanded', 'false');
    p.style.position = '';
    p.style.top = '';
    p.style.left = '';
    p.style.right = '';
    p.style.zIndex = '';
  }
  window.__tdLangOpenRoot = null;
};

window.toggleLangSwitcher = function (e) {
  if (e) e.stopPropagation();
  var trigger = e && e.currentTarget;
  if (!trigger) return;
  var root = trigger.closest('.td-lang-switcher');
  var p = root && root.querySelector('.td-lang-switcher-panel');
  var t = root && root.querySelector('.td-lang-switcher-trigger');
  if (!root || !p || !t) return;
  var opening = p.classList.contains('invisible');
  if (opening) {
    closeLangSwitcher();
    window.__tdLangOpenRoot = root;
    if (typeof closeAccountMenu === 'function') closeAccountMenu();
    if (typeof closeCustomerMenu === 'function') closeCustomerMenu();
    var searchO = document.getElementById('searchOverlay');
    if (searchO && !searchO.classList.contains('opacity-0') && typeof toggleSearch === 'function') toggleSearch();
    var menuO = document.getElementById('mobileMenuOverlay');
    var insideMobileDrawer = root.closest('#mobileMenuDrawer');
    if (menuO && !menuO.classList.contains('opacity-0') && !insideMobileDrawer && typeof toggleMobileMenu === 'function') {
      toggleMobileMenu();
    }
    var cartO = document.getElementById('cartDrawerOverlay');
    if (cartO && !cartO.classList.contains('opacity-0') && typeof toggleCartDrawer === 'function') toggleCartDrawer();
    p.classList.remove('pointer-events-none', 'invisible', 'opacity-0', 'scale-[0.98]');
    p.classList.add('pointer-events-auto', 'visible', 'opacity-100', 'scale-100');
    t.setAttribute('aria-expanded', 'true');
    if (typeof lucide !== 'undefined') lucide.createIcons();
    window.requestAnimationFrame(function () {
      positionLangSwitcherPanel();
      window.requestAnimationFrame(positionLangSwitcherPanel);
    });
  } else {
    closeLangSwitcher();
  }
};

window.addEventListener('resize', onLangSwitcherReposition);
window.addEventListener('scroll', onLangSwitcherReposition, true);

document.addEventListener('click', function (e) {
  if (!langSwitcherIsOpen()) return;
  var roots = document.querySelectorAll('.td-lang-switcher');
  var hit = false;
  for (var i = 0; i < roots.length; i++) {
    if (roots[i].contains(e.target)) {
      hit = true;
      break;
    }
  }
  if (!hit) closeLangSwitcher();
});

/* ── Search Overlay ── */
window.toggleSearch = function () {
  var overlay = document.getElementById('searchOverlay');
  var box = document.getElementById('searchBox');
  if (!overlay || !box) return;

  if (overlay.classList.contains('opacity-0')) {
    if (typeof closeAccountMenu === 'function') closeAccountMenu();
    if (typeof closeCustomerMenu === 'function') closeCustomerMenu();
    if (typeof closeLangSwitcher === 'function') closeLangSwitcher();
    overlay.classList.remove('opacity-0', 'pointer-events-none');
    box.classList.remove('translate-y-4', 'scale-95');
    setTimeout(function () {
      var input = document.getElementById('liveSearchInput');
      if (input) input.focus();
    }, 300);
  } else {
    overlay.classList.add('opacity-0', 'pointer-events-none');
    box.classList.add('translate-y-4', 'scale-95');
    var input = document.getElementById('liveSearchInput');
    if (input) input.value = '';
    var results = document.getElementById('liveSearchResults');
    var suggestions = document.getElementById('searchSuggestions');
    if (results) { results.innerHTML = ''; results.classList.add('hidden'); }
    if (suggestions) suggestions.classList.remove('hidden');
  }
};

/* Close search on overlay backdrop click */
document.addEventListener('click', function (e) {
  var overlay = document.getElementById('searchOverlay');
  var box = document.getElementById('searchBox');
  if (overlay && !overlay.classList.contains('opacity-0') && box && !box.contains(e.target) && e.target === overlay) {
    toggleSearch();
  }
});

/* Close account menu or search on ESC */
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    if (langSwitcherIsOpen()) {
      closeLangSwitcher();
      return;
    }
    if (accountMenuIsOpen()) {
      closeAccountMenu();
      return;
    }
    if (customerMenuIsOpen()) {
      closeCustomerMenu();
      return;
    }
    var overlay = document.getElementById('searchOverlay');
    if (overlay && !overlay.classList.contains('opacity-0')) toggleSearch();
  }
});

/* ── Live / Predictive Search ── */
(function () {
  var timer = null;
  var lastQuery = '';

  function renderResults(items) {
    var resultsEl = document.getElementById('liveSearchResults');
    var suggestionsEl = document.getElementById('searchSuggestions');
    if (!resultsEl) return;

    if (!items || items.length === 0) {
      var noRes = (window.themeStrings && window.themeStrings.searchNoResults) || 'No results';
      resultsEl.innerHTML = '<p class="py-6 text-center text-sm text-gray-400 font-semibold">' + noRes + '</p>';
      resultsEl.classList.remove('hidden');
      if (suggestionsEl) suggestionsEl.classList.add('hidden');
      return;
    }

    var html = '';
    items.slice(0, 6).forEach(function (item) {
      var loc = document.documentElement.lang || 'ar';
      var cur = (window.themeStrings && window.themeStrings.currencySymbol) || '';
      var price = item.price
        ? (parseInt(item.price) / 100).toLocaleString(loc) + (cur ? ' ' + cur : '')
        : '';
      var img = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url + '&width=80" class="w-10 h-10 object-contain rounded-lg shrink-0" alt="" width="80" height="80" loading="lazy" decoding="async">'
        : '<div class="w-10 h-10 bg-surface rounded-lg shrink-0 flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0v10l-8 4-8-4V7"/></svg></div>';
      html += '<a href="' + item.url + '" class="flex items-center gap-3 py-3 hover:bg-gray-50 rounded-xl px-2 transition-colors group">'
        + img
        + '<div class="flex-1 min-w-0">'
        + '<p class="text-sm font-bold text-black line-clamp-1 group-hover:text-brandTeal transition-colors">' + item.title + '</p>'
        + (price ? '<p class="text-xs font-bold text-gray-500 mt-0.5">' + price + '</p>' : '')
        + '</div>'
        + '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-300 group-hover:text-brandTeal shrink-0 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>'
        + '</a>';
    });

    if (items.length > 6) {
      var q = document.getElementById('liveSearchInput') ? document.getElementById('liveSearchInput').value : '';
      html += '<a href="/search?type=product&q=' + encodeURIComponent(q) + '" class="flex items-center justify-center gap-2 pt-3 pb-1 text-xs font-bold text-brandTeal hover:text-black transition-colors">'
        + 'عرض كل النتائج (' + items.length + ')'
        + '</a>';
    }

    resultsEl.innerHTML = html;
    resultsEl.classList.remove('hidden');
    if (suggestionsEl) suggestionsEl.classList.add('hidden');
  }

  function doSearch(q) {
    if (!q || q.trim().length < 2) {
      var resultsEl = document.getElementById('liveSearchResults');
      var suggestionsEl = document.getElementById('searchSuggestions');
      if (resultsEl) { resultsEl.innerHTML = ''; resultsEl.classList.add('hidden'); }
      if (suggestionsEl) suggestionsEl.classList.remove('hidden');
      return;
    }

    var _rr = (typeof window.TD_ROUTES_ROOT === 'string' && window.TD_ROUTES_ROOT) ? window.TD_ROUTES_ROOT.replace(/\/$/, '') : '';
    var _sugPrefix = !_rr || _rr === '/' ? '' : _rr;
    fetch(_sugPrefix + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = data && data.resources && data.resources.results && data.resources.results.products
          ? data.resources.results.products : [];
        renderResults(items);
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    var input = document.getElementById('liveSearchInput');
    if (!input) return;

    input.addEventListener('input', function () {
      var q = this.value.trim();
      if (q === lastQuery) return;
      lastQuery = q;
      clearTimeout(timer);
      timer = setTimeout(function () { doSearch(q); }, 280);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q) window.location.href = '/search?type=product&q=' + encodeURIComponent(q);
      }
    });
  });
}());

/* ── Scroll to Top ── */
var scrollToTopBtn = document.getElementById('scrollToTopBtn');
if (scrollToTopBtn) {
  window.addEventListener('scroll', function () {
    if (window.scrollY > 400) {
      scrollToTopBtn.classList.remove('translate-y-20', 'opacity-0', 'pointer-events-none');
    } else {
      scrollToTopBtn.classList.add('translate-y-20', 'opacity-0', 'pointer-events-none');
    }
  });
}

/* ── AJAX Add to Cart (بطاقة المنتج + أي نموذج بنفس البنية) — تفويض للعناصر المحقونة لاحقاً (مثلاً المفضلة) ── */
function setAddToCartLoading(form, isLoading) {
  var btn = form.querySelector('.ajax-atc-submit') || form.querySelector('[type="submit"]');
  if (!btn) return;
  var label = btn.querySelector('.ajax-atc-label');
  var spin = btn.querySelector('.ajax-atc-spinner');
  if (label && spin) {
    if (isLoading) {
      label.classList.add('hidden');
      spin.classList.remove('hidden');
      spin.classList.add('flex');
    } else {
      spin.classList.add('hidden');
      spin.classList.remove('flex');
      label.classList.remove('hidden');
    }
  }
  btn.disabled = !!isLoading;
  btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
}
window.setAddToCartLoading = setAddToCartLoading;

function tdCartAddJsUrl() {
  return (typeof window.TD_CART_ADD_JS === 'string' && window.TD_CART_ADD_JS) ? window.TD_CART_ADD_JS : '/cart/add.js';
}

function tdCartJsUrl() {
  var u = tdCartAddJsUrl();
  if (/\/cart\/add\.js(\?|$)/i.test(u)) return u.replace(/\/cart\/add\.js/i, '/cart.js');
  return '/cart.js';
}

document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form || !form.classList || !form.classList.contains('ajax-add-to-cart-form')) return;
  e.preventDefault();
  var btn = form.querySelector('.ajax-atc-submit') || form.querySelector('[type="submit"]');
  if (!btn || btn.disabled) return;
  setAddToCartLoading(form, true);
  if (typeof lucide !== 'undefined') lucide.createIcons();

  fetch(tdCartAddJsUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams(new FormData(form))
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart add failed');
      return res.json();
    })
    .then(function () {
      return fetch(tdCartJsUrl());
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      toggleCartDrawer();
      refreshCartDrawerItems();
    })
    .catch(function (err) { console.error(err); })
    .finally(function () {
      setAddToCartLoading(form, false);
      if (typeof lucide !== 'undefined') lucide.createIcons();
    });
});

/* ── Cart Count Badge ── */
function updateCartCount(count) {
  var badge = document.getElementById('cart-count');
  if (badge) {
    badge.textContent = count;
    if (count > 0) {
      badge.classList.remove('hidden');
    } else {
      badge.classList.add('hidden');
    }
  }
  var drawerCount = document.getElementById('drawer-item-count');
  if (drawerCount) {
    var suffix = (window.themeStrings && window.themeStrings.cartItemsLabel) ? window.themeStrings.cartItemsLabel : '';
    drawerCount.textContent = suffix ? count + ' ' + suffix : String(count);
  }
}

/**
 * الدفع عبر رابط السلة الدائم (نفس «اشتر الآن»): /cart/VARIANT:QTY,...
 * يعمل مع shopify theme dev (نفق مختلف عن myshopify) لأن التوجيه يتم على نطاق المتجر الأساسي مع السلة في الرابط.
 */
function tdCartPermalinkSegments(items) {
  if (!items || !items.length) return '';
  return items
    .map(function (line) {
      return String(line.variant_id) + ':' + String(line.quantity);
    })
    .join(',');
}

function tdGoCheckoutPermalink(ev) {
  if (ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }
  var base =
    typeof window.TD_CART_PERMALINK_BASE === 'string' && window.TD_CART_PERMALINK_BASE
      ? window.TD_CART_PERMALINK_BASE.replace(/\/$/, '')
      : '';
  if (!base) {
    base = (window.location.origin || '').replace(/\/$/, '') + '/cart';
  }
  fetch(tdCartJsUrl(), { credentials: 'same-origin' })
    .then(function (r) {
      if (!r.ok) throw new Error('cart.js');
      return r.json();
    })
    .then(function (cart) {
      var seg = tdCartPermalinkSegments(cart && cart.items);
      if (!seg) return;
      window.location.assign(base + '/' + seg);
    })
    .catch(function (err) {
      console.error(err);
    });
}

document.addEventListener('click', function (e) {
  if (!e.target.closest('[data-td-checkout-permalink]')) return;
  tdGoCheckoutPermalink(e);
});

/* ── Update Cart Item Quantity ── */
window.updateCartItem = function (key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(function (res) { return res.json(); })
  .then(function (cart) {
    updateCartCount(cart.item_count);
    refreshCartDrawerItems();
  })
  .catch(function (err) { console.error(err); });
};

/* ── Remove Cart Item ── */
window.removeCartItem = function (key) {
  updateCartItem(key, 0);
};

/* ── Refresh Cart Drawer via Shopify Sections API (العناصر + التذييل/المجموع) ── */
function refreshCartDrawerItems() {
  fetch('/?sections=cart-drawer')
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (!data['cart-drawer']) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(data['cart-drawer'], 'text/html');
      var newItems = doc.getElementById('cart-drawer-items');
      var currentItems = document.getElementById('cart-drawer-items');
      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
      }
      var newFooter = doc.getElementById('cart-drawer-footer');
      var currentFooter = document.getElementById('cart-drawer-footer');
      if (newFooter && currentFooter) {
        currentFooter.className = newFooter.className;
        currentFooter.innerHTML = newFooter.innerHTML;
      }
      if (typeof lucide !== 'undefined') lucide.createIcons();
    })
    .catch(function (err) { console.error(err); });
}

window.refreshCartDrawerItems = refreshCartDrawerItems;

/* ── Local wishlist (localStorage — no Shopify native wishlist) ── */
(function () {
  var STORAGE_KEY = 'td_wishlist_v1';

  function readList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function refreshWishlistBadge() {
    var n = readList().length;
    document.querySelectorAll('.wishlist-count-badge').forEach(function (el) {
      el.textContent = String(n);
      if (n > 0) el.classList.remove('hidden');
      else el.classList.add('hidden');
    });
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    window.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { items: list } }));
  }

  function wishlistProductPath(handle) {
    var root = (typeof window.TD_ROUTES_ROOT === 'string' && window.TD_ROUTES_ROOT) ? window.TD_ROUTES_ROOT : '/';
    var r = String(root).replace(/\/$/, '');
    var p = '/products/' + encodeURIComponent(handle);
    if (!r || r === '') return p;
    return r + p;
  }

  function wishlistCardFetchUrl(handle) {
    return wishlistProductPath(handle) + '?view=wishlist-card';
  }

  function wishlistRemoveBtnHtml(pid) {
    return (
      '<button type="button" class="wishlist-remove pointer-events-auto absolute end-2 top-2 z-[25] flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 shadow-sm hover:border-red-200 hover:text-red-500" data-wishlist-remove="' +
      escapeHtml(String(pid)) +
      '" aria-label="' +
      escapeHtml(window.themeStrings && window.themeStrings.wishlistRemove ? window.themeStrings.wishlistRemove : 'Remove') +
      '"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>'
    );
  }

  function renderWishlistFallbackSlot(slot, entry) {
    var pid = String(entry.id);
    var url = wishlistProductPath(entry.handle);
    var rawTitle = String(entry.title || entry.handle || '?');
    var title = escapeHtml(rawTitle);
    var imgUrl = entry.image ? escapeHtml(entry.image) : '';
    var wlTitle = escapeHtml(entry.title || '');
    var wlImg = entry.image ? escapeHtml(entry.image) : '';
    var hint = escapeHtml(window.themeStrings && window.themeStrings.wishlistFallbackHint ? window.themeStrings.wishlistFallbackHint : '');
    var imgBlock = imgUrl
      ? '<a href="' +
        escapeHtml(url) +
        '" class="relative flex aspect-square items-center justify-center overflow-hidden rounded-xl border border-gray-100 bg-gray-50 p-3"><img src="' +
        imgUrl +
        '" alt="" class="max-h-full max-w-full object-contain" loading="lazy" width="200" height="200"></a>'
      : '<a href="' +
        escapeHtml(url) +
        '" class="flex aspect-square items-center justify-center rounded-xl border border-gray-100 bg-gray-50 text-lg font-bold text-gray-400">' +
        escapeHtml(rawTitle.charAt(0).toUpperCase()) +
        '</a>';
    var heart =
      '<button type="button" class="wishlist-btn wishlist-btn--active absolute start-2 top-2 z-[20] flex h-9 w-9 items-center justify-center rounded-full border border-gray-100 bg-white text-red-500 shadow-sm" data-product-id="' +
      escapeHtml(pid) +
      '" data-product-handle="' +
      escapeHtml(entry.handle) +
      '" data-product-title="' +
      wlTitle +
      '" ' +
      (wlImg ? 'data-product-image="' + wlImg + '" ' : '') +
      'aria-pressed="true" aria-label="Wishlist"><i data-lucide="heart" class="h-5 w-5"></i></button>';
    slot.innerHTML =
      '<div class="relative flex min-h-0 flex-col overflow-hidden rounded-[1.25rem] border border-amber-100/80 bg-white p-3 shadow-product">' +
      wishlistRemoveBtnHtml(pid) +
      heart +
      imgBlock +
      '<div class="mt-3 flex min-w-0 flex-1 flex-col gap-1.5 text-start">' +
      '<a href="' +
      escapeHtml(url) +
      '" class="line-clamp-2 text-sm font-bold text-black hover:text-brandTeal">' +
      title +
      '</a>' +
      (hint ? '<p class="text-xs font-medium text-amber-800/90">' + hint + '</p>' : '') +
      '</div></div>';
    slot.querySelectorAll('.wishlist-btn').forEach(syncWishlistBtn);
    if (typeof lucide !== 'undefined') lucide.createIcons();
  }

  function isWishlisted(productId) {
    var id = String(productId);
    return readList().some(function (x) { return String(x.id) === id; });
  }

  function toggle(entry) {
    var list = readList();
    var id = String(entry.id);
    var idx = list.findIndex(function (x) { return String(x.id) === id; });
    var added;
    if (idx >= 0) {
      list.splice(idx, 1);
      added = false;
    } else {
      list.push({
        id: entry.id,
        handle: entry.handle || '',
        title: entry.title || '',
        image: entry.image || ''
      });
      added = true;
    }
    writeList(list);
    return added;
  }

  function removeById(productId) {
    var id = String(productId);
    var list = readList().filter(function (x) { return String(x.id) !== id; });
    writeList(list);
  }

  function syncWishlistBtn(btn) {
    if (!btn || !btn.classList.contains('wishlist-btn')) return;
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    var active = isWishlisted(id);
    btn.classList.toggle('wishlist-btn--active', active);
    btn.classList.toggle('text-red-500', active);
    btn.classList.toggle('text-gray-300', !active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var icon = btn.querySelector('svg');
    if (icon) {
      if (active) {
        icon.setAttribute('fill', 'currentColor');
        icon.setAttribute('stroke', 'currentColor');
      } else {
        icon.setAttribute('fill', 'none');
      }
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] || c;
    });
  }

  function renderWishlistPage() {
    var root = document.getElementById('wishlist-page-root');
    if (!root) return;
    var grid = document.getElementById('wishlist-grid');
    var emptyEl = document.getElementById('wishlist-empty');
    if (!grid || !emptyEl) return;

    var list = readList();
    grid.innerHTML = '';

    if (list.length === 0) {
      emptyEl.classList.remove('hidden');
      return;
    }
    emptyEl.classList.add('hidden');

    list.forEach(function (entry) {
      if (!entry.handle) return;
      var slot = document.createElement('div');
      slot.className = 'td-wishlist-slot relative min-w-0';
      slot.innerHTML =
        '<p class="rounded-[1.25rem] border border-gray-100 bg-white p-6 text-sm text-gray-400 animate-pulse">' +
        escapeHtml(window.themeStrings && window.themeStrings.wishlistLoading ? window.themeStrings.wishlistLoading : '…') +
        '</p>';
      grid.appendChild(slot);

      fetch(wishlistCardFetchUrl(entry.handle), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) {
          if (!r.ok) throw new Error('bad');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var pc = doc.querySelector('.product-card');
          if (!pc) {
            renderWishlistFallbackSlot(slot, entry);
            return;
          }
          var pid = pc.querySelector('.wishlist-btn') && pc.querySelector('.wishlist-btn').getAttribute('data-product-id');
          pid = pid || String(entry.id);
          slot.innerHTML =
            wishlistRemoveBtnHtml(pid) + '<div class="td-wishlist-card-inner min-w-0">' + pc.outerHTML + '</div>';
          slot.querySelectorAll('.wishlist-btn').forEach(syncWishlistBtn);
          if (typeof lucide !== 'undefined') lucide.createIcons();
        })
        .catch(function () {
          renderWishlistFallbackSlot(slot, entry);
        });
    });
  }

  window.TDWishlist = {
    read: readList,
    isWishlisted: isWishlisted,
    toggle: toggle,
    remove: removeById,
    renderPage: renderWishlistPage
  };

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-wishlist-remove]');
    if (rm) {
      e.preventDefault();
      removeById(rm.getAttribute('data-wishlist-remove'));
      renderWishlistPage();
      document.querySelectorAll('.wishlist-btn').forEach(syncWishlistBtn);
      if (typeof lucide !== 'undefined') lucide.createIcons();
      return;
    }

    var btn = e.target.closest('.wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-product-id');
    var handle = btn.getAttribute('data-product-handle');
    if (!id || !handle) return;
    var title = btn.getAttribute('data-product-title') || '';
    var image = btn.getAttribute('data-product-image') || '';
    toggle({ id: id, handle: handle, title: title, image: image });
    syncWishlistBtn(btn);
    if (typeof lucide !== 'undefined') lucide.createIcons();
  });

  document.addEventListener('DOMContentLoaded', function () {
    refreshWishlistBadge();
    document.querySelectorAll('.wishlist-btn').forEach(syncWishlistBtn);
    if (document.getElementById('wishlist-page-root')) {
      renderWishlistPage();
    }
  });

  window.addEventListener('wishlist:changed', function () {
    refreshWishlistBadge();
    document.querySelectorAll('.wishlist-btn').forEach(syncWishlistBtn);
    if (document.getElementById('wishlist-page-root')) {
      renderWishlistPage();
    }
    if (typeof lucide !== 'undefined') lucide.createIcons();
  });
})();

(function tdHeaderPin() {
  var hdr;
  var ann;
  var sp;
  var sent;
  var ticking;
  /** عندما يوجد #tdPinSentinel: true إذا خرج من نافذة العرض (المستخدم مرّر للأسفل) */
  var pinFromSentinel = false;
  /** false إذا لا يوجد مرجع أو المتصفح لا يدعم IntersectionObserver — نرجع لـ scrollY */
  var sentinelPinEnabled = false;
  var io;

  function scrollTop() {
    var se = document.scrollingElement;
    if (se && typeof se.scrollTop === 'number') {
      return se.scrollTop;
    }
    return (
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      (document.body && document.body.scrollTop) ||
      0
    );
  }

  function computePin(y) {
    if (sentinelPinEnabled) return pinFromSentinel;
    return y > 2;
  }

  function apply() {
    ticking = false;
    hdr = hdr || document.getElementById('siteHeader');
    ann = ann || document.getElementById('tdAnnouncement');
    sp = sp || document.getElementById('tdHeaderSpacer');
    sent = sent || document.getElementById('tdPinSentinel');
    var y = scrollTop();
    var pin = computePin(y);

    if (hdr) {
      if (pin) {
        if (!hdr.classList.contains('td-js-header-pinned')) {
          var h0 = Math.round(hdr.offsetHeight || hdr.getBoundingClientRect().height) || 64;
          if (sp) sp.style.height = h0 + 'px';
          hdr.classList.add('td-js-header-pinned');
        } else if (sp) {
          var h1 = Math.round(hdr.offsetHeight) || 64;
          sp.style.height = h1 + 'px';
        }
      } else {
        hdr.classList.remove('td-js-header-pinned');
        if (sp) sp.style.height = '0px';
      }
      if (y > 12) hdr.classList.add('td-header-scrolled');
      else hdr.classList.remove('td-header-scrolled');
    }

    if (ann) {
      ann.hidden = pin;
      ann.setAttribute('aria-hidden', pin ? 'true' : 'false');
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  function bindSentinelIO() {
    sent = document.getElementById('tdPinSentinel');
    sentinelPinEnabled = false;
    if (io) {
      io.disconnect();
      io = null;
    }
    if (!sent || typeof IntersectionObserver === 'undefined') return;
    pinFromSentinel = false;
    io = new IntersectionObserver(
      function (entries) {
        var e = entries[0];
        if (!e) return;
        pinFromSentinel = !e.isIntersecting;
        apply();
      },
      { root: null, threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );
    io.observe(sent);
    sentinelPinEnabled = true;
    var rec = io.takeRecords();
    if (rec.length) {
      pinFromSentinel = !rec[0].isIntersecting;
    }
  }

  function init() {
    bindSentinelIO();
    apply();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', function () {
    bindSentinelIO();
    onScroll();
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();

/**
 * حسابات العملاء الجديدة في Shopify قد لا يملأ Liquid المتغير {{ customer }} على الواجهة رغم الدخول.
 * نختبر /account: إن لم يُحمَل مسار الدخول نعرض قائمة الملف والطلبات بدل أزرار Shop/البريد.
 */
(function tdNewCustomerAccountHeaderProbe() {
  function looksLikeLoginUrl(urlStr) {
    return /customer_authentication|\/account\/login|authentication\/login|\/password\b/i.test(urlStr);
  }

  function run() {
    var logged = document.querySelector('.td-header-account-logged');
    var guest = document.querySelector('.td-header-account-guest');
    if (!logged || !guest) return;
    if (!logged.classList.contains('hidden')) return;
    if (guest.classList.contains('hidden')) return;

    var origin = window.location.origin;
    fetch(origin + '/account', {
      credentials: 'same-origin',
      redirect: 'follow',
      mode: 'same-origin',
      headers: { Accept: 'text/html,application/xhtml+xml' },
    })
      .then(function (res) {
        var u = res.url || '';
        if (looksLikeLoginUrl(u)) return;
        if (!/account/i.test(u)) return;
        if (typeof closeAccountMenu === 'function') closeAccountMenu();
        logged.classList.remove('hidden');
        guest.classList.add('hidden');
        logged.removeAttribute('aria-hidden');
        guest.setAttribute('aria-hidden', 'true');
        if (typeof lucide !== 'undefined') lucide.createIcons();
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
